'use client';

import { useEffect } from 'react';

export default function ServiceWorkerRegister() {
  useEffect(() => {
    const isExplicitlyDisabled = process.env.NEXT_PUBLIC_DISABLE_SERVICE_WORKER === 'true';
    const isDevEnabled = process.env.NEXT_PUBLIC_ENABLE_DEV_SERVICE_WORKER === 'true';
    const isProductionEnabled =
      process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator;

    if (!isExplicitlyDisabled && (isDevEnabled || isProductionEnabled)) {
      navigator.serviceWorker.register('/sw.js').catch((err) => {
        console.error('ServiceWorker registration failed:', err);
      });
    }
  }, []);

  return null;
}
